import Vue from 'vue';
import axios from 'axios';
import get from 'lodash/get';

export default {
  /**
   * Gets a list of all devices being assigned to a user.
   *
   * @returns {Promise}
   */
  getDevices() {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios.get(`${BASE_PATH}/devices`).then(response => response.data);
  },

  /**
   * Gets a device with serial number.
   *
   * @returns {Promise}
   */
  getDeviceWithSn(sn) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    if (sn === undefined) throw new Error('no valid device serial');
    return axios.get(`${BASE_PATH}/devices/${sn}`).then(response => response.data);
  },

  /**
   * get the device data
   *
   * @returns {Promise}
   */
  getDeviceData(sn, apps) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    if (sn === undefined) throw new Error('no valid device serial');
    return axios
      .get(`${BASE_PATH}/devices/${sn}/apps/${apps.toString()}/data?last=1`)
      .then(response => response.data);
  },

  /**
   * get battery qty
   *
   * @returns {Promise}
   */
  getBatteryQty(sn, apps) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    if (sn === undefined) throw new Error('no valid device serial');
    return axios
      .get(`${BASE_PATH}/devices/${sn}/apps/${apps.toString()}/data?last=1`)
      .then(response => response.data);
  },

  /**
   * get api version
   *
   * @returns {Promise}
   */
  getApiVersion() {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios.get(`${BASE_PATH}/state`).then(response => response.data);
  },

  /**
   * patch submit the address to device
   *
   * @returns {Promise}
   */
  submitAddressToDevice(configObj) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios
      .patch(`${BASE_PATH}/devices/${configObj.serial}/profile`, configObj.profile)
      .then(response => response.data);
  },

  /**
   * assign device to technician
   *
   * @param {object} configObj - object with serial and email
   * @returns {Promise}
   */
  assignDeviceToTechnician(configObj) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios
      .post(`${BASE_PATH}/devices/${configObj.serial}/maintenance_access`, {
        email: configObj.technicianMail || ''
      })
      .then(response => response.data);
  },

  /**
   * get list of all assigned technicians
   *
   * @param {object} configObj - object with serial and email
   * @returns {Promise}
   */
  getTechnicianList(configObj) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios
      .get(`${BASE_PATH}/devices/${configObj.serial}/maintenance_access`)
      .then(response => response.data);
  },

  /**
   * remove access for technician for given device
   *
   * @param {object} configObj - object with serial and email
   * @returns {Promise}
   */
  revokeTechnicianAccess(configObj) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    if (!configObj.serial) return;
    return axios
      .delete(`${BASE_PATH}/devices/${configObj.serial}/maintenance_access`, {
        data: { email: configObj.technicianMail || '' }
      })
      .then(response => response.data);
  },

  /**
   * send new expertview settings to cloud
   *
   * @returns {Promise}
   */
  submitExpertSettings(configObj) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios
      .post(`${BASE_PATH}/devices/${configObj.serial}/events`, configObj.data)
      .then(response => response.data);
  },

  getEmailPeriodStats(configObj) {
    const BASE_PATH = get(Vue.config.metadata, 'location', '');
    return axios
      .post(`${BASE_PATH}/devices/${configObj.serial}/email_period_stats`, configObj.data)
      .then(response => response.data);
  }
};
